module.exports = {"513427100":"披砂镇","513427101":"松新镇","513427102":"竹寿镇","513427103":"华弹镇","513427104":"白鹤滩镇","513427105":"葫芦口镇","513427106":"西瑶镇","513427107":"景星镇","513427108":"大同镇","513427109":"骑骡沟镇","513427110":"跑马镇","513427111":"幸福镇","513427112":"石梨镇","513427113":"六铁镇","513427114":"松林镇","513427115":"新华镇","513427201":"俱乐乡","513427202":"新村乡","513427204":"海子乡","513427206":"新建乡","513427207":"稻谷乡","513427211":"杉树乡","513427212":"梁子乡","513427215":"红星乡","513427217":"倮格乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513427.json
// module id = 2436
// module chunks = 0